import http from "./http";

export type AdminStationPortalLogRecord = {
	id: number;
	sourceApp: string;
	eventType: string;
	level: string;
	action: string;
	message: string | null;
	route: string | null;
	requestPath: string | null;
	requestMethod: string | null;
	statusCode: number | null;
	userId: number | null;
	partnerId: number | null;
	actorEmail: string | null;
	metadata: Record<string, any> | null;
	ipAddress: string | null;
	userAgent: string | null;
	occurredAt: string;
	createdAt: string;
	updatedAt: string;
	user?: {
		id: number;
		fullName?: string | null;
		email?: string | null;
		role?: number | null;
	} | null;
	partner?: {
		id: number;
		name?: string | null;
		displayName?: string | null;
		userId?: number | null;
	} | null;
};

export type GetAdminStationPortalLogsParams = {
	page?: number;
	limit?: number;
	sourceApp?: string;
	eventType?: string;
	level?: string;
	action?: string;
	userId?: string;
	partnerId?: string;
	actorEmail?: string;
	route?: string;
	statusCode?: string;
	search?: string;
	fromDate?: string;
	toDate?: string;
};

export async function getAdminStationPortalLogs(params: GetAdminStationPortalLogsParams = {}): Promise<{
	data: AdminStationPortalLogRecord[];
	total: number;
	page: number;
	limit: number;
}> {
	const { data } = await http.get("/admin/station-portal-logs", { params });
	return {
		data: (data?.data || []) as AdminStationPortalLogRecord[],
		total: data?.total || 0,
		page: data?.page || 1,
		limit: data?.limit || params.limit || 20,
	};
}

// Tham số cho chế độ phân trang con trỏ: kế thừa bộ lọc cũ, thêm cursor tuỳ chọn
// (không truyền cursor = trang đầu tiên của chế độ con trỏ).
export type GetLogsByCursorParams = GetAdminStationPortalLogsParams & { cursor?: string };

export async function getAdminStationPortalLogsByCursor(params: GetLogsByCursorParams = {}): Promise<{
	data: AdminStationPortalLogRecord[];
	limit: number;
	nextCursor: string | null;
}> {
	// useCursor: 1 để server biết dùng chế độ con trỏ ngay cả ở trang đầu tiên,
	// lúc chưa có cursor nào.
	const { data } = await http.get("/admin/station-portal-logs", {
		params: { ...params, useCursor: 1 },
	});
	return {
		data: (data?.data || []) as AdminStationPortalLogRecord[],
		limit: data?.limit || params.limit || 50,
		// Backend LUÔN trả nextCursor tường minh là null khi hết dòng (không phải undefined) —
		// dùng ?? vẫn an toàn cho cả hai trường hợp.
		nextCursor: data?.nextCursor ?? null,
	};
}
